export const environment = {
  production: false,
  api_url: 'http://127.0.0.1:4000',
  baseRoutePath: '',
};
